import { render } from "./BaseIconFood.vue?vue&type=template&id=3a2a3b5a"
import script from "./BaseIconFood.vue?vue&type=script&lang=js"
export * from "./BaseIconFood.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BaseIconFood.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a2a3b5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a2a3b5a', __exports__)) {
    console.log('reload')
    api.reload('3a2a3b5a', __exports__)
  }
  
  module.hot.accept("./BaseIconFood.vue?vue&type=template&id=3a2a3b5a", () => {
    console.log('re-render')
    api.rerender('3a2a3b5a', render)
  })

}


export default __exports__